import apiClient from '../utils/apiClient';
import { PortalUserListDTO, ModuleRolePermissionsDto, PortalUserFailedLoginAttemptCountDto, PortalUserLisRequest } from '../types/PortalUser';
import { UserModuleRolePermission } from '../types/UserModuleRolePermission';
 
export const getPortalUserList = async (portalUserLisRequest? :PortalUserLisRequest): Promise<PortalUserListDTO[]> => {
   const response = await apiClient.post<PortalUserListDTO[]>(`/Portal/user-list`, portalUserLisRequest);
   return response.data;
 };


 export const getModulesByRoleId = async (roleId? :number): Promise<ModuleRolePermissionsDto[]> => {
  const response = await apiClient.get<ModuleRolePermissionsDto[]>(`/Portal/GetModulesByRoleId/${roleId}`);
  return response.data;
};

export const updatePortalUserFailedLoginAttemptCount = async (portalUserFailedLoginAttemptCount :PortalUserFailedLoginAttemptCountDto): Promise<string> => {
  const response = await apiClient.put<string>(`/Portal/user-failed-login-attempt`,{...portalUserFailedLoginAttemptCount});
  return response.data;
};

export const getUserModuleRolePermissions = async (userId? :number): Promise<UserModuleRolePermission[]> => {
  const response = await apiClient.get<UserModuleRolePermission[]>(`/Portal/user-module-role-permissions/${userId}`);
  return response.data;
};

 